import React,{useState} from 'react';
import Navbar from '../../components/LandingComponents/Navbar';
import styles from './faq.module.css'
import faqImg from '../../assets/images/shapearc.png'
import arrowDown from '../../assets/icons/arrowDown.svg'
import arrowUp from '../../assets/icons/arrowUp.svg'
import Footer from '../../components/LandingComponents/Footer';
import WhatsAppFloatButton from '../../components/LandingComponents/WhatsAppFloatButton';
import { WHATSAPP_URL } from '../../constants/whatsapp';

const FAQPage = () => {

    const [val, setVal] = useState(null);

    const toggleCard = (id) => {
       setVal(id === val ? null : id)      
     };
  
     const FAQS = [
       {
         id: 1,
         title: "How do I trade on Cardbarter?",
         content: () => (
           <>
           <ul className='ml-3'>
             <li>
               Tap <a href={WHATSAPP_URL} target="_blank" rel="noreferrer">Trade on WhatsApp</a> on our website or message us directly at +2349040337331.
             </li>
             <li>
               Tell us the type of gift card you want to sell and share a clear photo of the card.
             </li>
             <li>
               We will confirm the rate and send you the naira equivalent for your card denomination.
             </li>
             <li>
               Once you accept the rate, we verify your gift card and process the trade.
             </li>
             <li>
               Share your bank account details on WhatsApp and receive your payout.
             </li>
           </ul>
           </>
         ),
       },
       {
         id: 2,
         title: "What gift cards can I sell?",
         content: () => <>
         Gift cards supported on Cardbarter include Amazon, American Express (AMEX), Apple Store, Best Buy, eBay, Footlocker, Gamestop, Google Play, iTunes, Macy&apos;s, NIKE, Nordstrom, Offgamers, Walmart, Sephora, and many others. Message us on WhatsApp to confirm if we accept your card type.
         </>
       },
       {
         id: 3,
         title: "Do you trade on WhatsApp?",
         content: () => (
           <>
           Yes. Trading on WhatsApp is how we serve customers right now. Message us at{' '}
           <a href={WHATSAPP_URL} target="_blank" rel="noreferrer">+2349040337331</a>{' '}
           to start a trade, get live rates, and receive support from our team.
           </>
         ),
       },
       {
         id: 4,
         title: "How do I get paid after a trade?",
         content: () => <>
         After your trade is confirmed on WhatsApp, send us your bank account details (account name, account number, and bank name). We process your payout directly to that account — no dashboard or wallet login required.
         </>
       }, 
       {
        id: 5,
        title: "How long do I have to wait to receive my payment?",
        content: () => <>
        Payouts are processed quickly after a successful trade — typically within 5 minutes. Banks occasionally experience delays that are beyond our control. If you do not receive your payment within 24 hours, reach out to us on WhatsApp and we will look into it.
        </>
       }, 
       {
        id: 6,
        title: "Why is my trade rejected?",
        content: () => <>
         There are a set of reasons why your trade might be rejected:
        <ul className='ml-3 mb-1'>
          <li>
          You submitted a blank or incomplete trade
          </li>
          <li>
          Your gift card image is not clear enough
          </li>
          <li>
          Your gift card has already been used
          </li>
          <li>
          Your gift card code is incorrect
          </li>
          <li>
          Your gift card is not activated yet, and so on
          </li>
        </ul>
        We will always explain the reason for any rejection on WhatsApp.
        </>
      },    
     ];

    return ( 
        <>
            <Navbar hideAuth />
            <div className={styles.faq_section}>
                <div className='contain'>

                    <div className={styles.titleDiv}>
                        <img src={faqImg} alt="faqbg" className='img-fluid' />
                        <h3 className={styles.title}>Frequently Asked Questions</h3>
                    </div>

                    {/* Frequently asked questions section */}
                    <div className={`mt-5 ${styles.faq_card}`}>
                            {FAQS.map(({ id, title, content }) => (
                                <div key={id}
                                onClick={() => toggleCard(id)}
                                className={`mb-3 mb-md-3 ${styles.card}`}>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <p className={styles.faq_title}>
                                        {title}
                                        </p>
                                        <img 
                                         src={val === id ? arrowDown : arrowUp}
                                         alt="arrow" style={{cursor: 'pointer'}} width='30' height='30' className='img-fluid' />      
                                    </div>
        
                                    <div className={
                                            val === id
                                            ? "d-block mt-4"
                                            : "d-none mt-4"
                                        }
                                        >
                                        <p className={styles.faq_content}>
                                            {content()}
                                        </p>
                                    </div>
                                </div>    
                            ))}
                        
                    </div>



                </div>

            </div>
            <Footer/>
            <WhatsAppFloatButton />
        </>
     );
}
 
export default FAQPage;